import React from 'react'
import * as System from 'styled-system'
import { Box, Flex } from '@revolut/ui-kit'

type DividerPropTypes = {
  borderSize?: string | number
  borderColor?: any // TODO: Use ui-kit types when they're ready
  space?: System.ResponsiveValue<string | number>
  children?: React.ReactNode
} & React.ComponentPropsWithoutRef<typeof Flex>

const DEFAULT_SPACE = 2

// Divider component copy from Business app
export const Divider = ({
  borderSize = '1px',
  borderColor = 'grey-90',
  space = DEFAULT_SPACE,
  children,
  ...rest
}: DividerPropTypes) => (
  <Flex alignItems='center' {...rest}>
    <Box flex='1' height={borderSize} bg={borderColor} />
    {children && <Box px={space}>{children}</Box>}
    <Box flex='1' height={borderSize} bg={borderColor} />
  </Flex>
)
